import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("circle", {
        cx: "7",
        cy: "7",
        r: "7",
        fill: "#fff"
      }),
      _createElementVNode("path", {
        fill: "currentcolor",
        d: "M7.038 3.23a.5.5 0 0 1 .5.5v2.73l2.731.002a.5.5 0 0 1 .5.5v.076a.5.5 0 0 1-.5.5H7.538v2.731a.5.5 0 0 1-.5.5h-.076a.5.5 0 0 1-.5-.5L6.46 7.538H3.73a.5.5 0 0 1-.5-.5v-.076a.5.5 0 0 1 .5-.5l2.73-.001V3.73a.5.5 0 0 1 .5-.5z"
      })
    ], -1)
  ]))]))
}
export default { render: render }